import { comparator } from '@fi-shared/utils/array-sort-comparators';
import { IFiCustomerDataCustomButton } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiApplicationLanguageType } from '@fi-shared/fi-content-language-shared/fi-application-language-type';

export class CustomButtonModel implements IFiCustomerDataCustomButton {
    Captions: {
        Text: string;
        LanguageId: number;
    }[];
    Names: {
        Text: string;
        LanguageId: number;
    }[];
    IconClass: string;
    Id: number;
    SortIndex: number;
    IsSelected: boolean;
    OpenInSameWindow: boolean;
    Url: string;
    orderedLangs: any[];

    constructor(
        data,
        applicationLanguage: FiApplicationLanguageType,
        defaultApplicationLanguageType: FiApplicationLanguageType,
    ) {
        this.Captions = data.Captions || [];
        this.Names = data.Names || [];
        this.IconClass = data.IconClass;
        this.Id = data.Id;
        this.Url = data.Url;
        this.SortIndex = data.SortIndex;
        this.IsSelected = false;
        this.OpenInSameWindow = data.OpenInSameWindow;
        this.orderedLangs = [applicationLanguage, defaultApplicationLanguageType];
    }

    GetCaption() {
        this.Captions.sort(
            comparator((item) => {
                const idx = this.orderedLangs.indexOf(item.LanguageId);
                return idx !== -1 ? idx : Number.MAX_SAFE_INTEGER;
            }),
        );
        return this.Captions.length ? this.Captions[0].Text : this.Url;
    }

    // note: not used ?
    GetName() {
        this.Names.sort(comparator((item) => this.orderedLangs.indexOf(item.LanguageId)));

        return this.Names.length && this.Names[0] ? this.Names[0].Text : this.GetCaption();
    }
}
